import React, { useCallback, useMemo, useRef, useState } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { Editing } from 'devextreme-react/gantt';
import styles from './inputModalSemiProduct.module.scss';
import { columnDataGrid } from './columnDataGrid';
import { productionStoringNames } from '../constants';

const InputModalSemiProduct = ({ inputOperationReducer, storingName }) => {
  // eslint-disable-next-line
  const [state, setState] = useState({
    editRowKey: {
      batchId: null,
      cgId: null,
      actualPieceId: null,
      weight: null,
      weightRemain: null,
      percentWasteMaterial: null,
      weightCurrent: null,
      weightWasteMaterialCurrent: null,
      weightOff: null,
      pieceNumId: null
    }
  });

  const dataGridRef = useRef();

  const dataSource = useMemo(() => {
    return inputOperationReducer.operationMaterials.operationPieces;
  }, [inputOperationReducer.operationMaterials.operationPieces]);

  const onEditingStart = useCallback(
    (e) => {
      setState({ editRowKey: e.key });
    },
    [setState]
  );

  const isEditable = (item) =>
    (storingName === productionStoringNames.dataGridInputTrim
      || storingName === productionStoringNames.dataGridInputWaste)
    && !!item.editable;

  return (
    <DataGrid
      ref={dataGridRef}
      dataSource={dataSource}
      showBorders
      columnAutoWidth
      onRowUpdated={(e) => console.log({ updatedPar: e })}
      elementAttr={{ class: `${styles.dataGrid} shipment` }}
      onEditingStart={onEditingStart}
    >
      <Editing allowUpdating selectTextOnEditStart mode="cell" />
      {columnDataGrid.map((item) => (
        <Column
          dataField={item.dataField}
          caption={item.caption}
          visible={!item.notVisible}
          key={item.dataField}
          cellRender={item.cellRender}
          allowEditing={isEditable(item)}
          dataType={item.dataType}
          cssClass={isEditable(item) ? styles.editableCell : item.cssClass}
          width={item.width ? item.width : undefined}
        />
      ))}
        <Column
          dataField={'weightOff'}
          caption={'Кол-во списания'}
          visible={storingName !== productionStoringNames.dataGridInputAllWaste}
          key={'weightOff'}
          allowEditing={true}
          dataType={'number'}
          cssClass={styles.editableCell}
        />
    </DataGrid>
  );
};

export default InputModalSemiProduct;
